export const version = '0.399.1'
export const chameleonWebVersion = '0.0.0-1.0.0-5.0-0-0-snapshot-20230606150531-listbox-updates.608a853-20230801172725'
